import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';

export interface FixedPointShiftSessionInputDto {
  cdDelivery: number;
  startTime: string;
}

@Injectable()
export class FixedPointShiftSessionService {
  protected basePath = '/';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  public create(
    dto: FixedPointShiftSessionInputDto,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<number> {
    let headers = this.defaultHeaders;
    headers = headers.set('Accept', 'application/json').set('Content-Type', 'application/json');
    return this.httpClient.request<number>(
      'post',
      `${this.basePath}/api/FixedPointShiftSession/Create`,
      {
        body: dto,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }

  public endShift(
    id: number,
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<boolean> {
    let headers = this.defaultHeaders;
    headers = headers.set('Accept', 'application/json');
    return this.httpClient.request<boolean>(
      'post',
      `${this.basePath}/api/FixedPointShiftSession/EndShift/${encodeURIComponent(String(id))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress,
      }
    );
  }
}
